import {pipe} from 'lib/helpers'

export default (state) => (
    pipe(state)
)


// WEBPACK FOOTER //
// ./rewires/index.js